export function normalizePhoneToE164(rawPhone, defaultCountryCode) {
  const raw = String(rawPhone || "").trim();
  const country = String(defaultCountryCode || "").replace(/\D/g, "");
  if (!raw) {
    return { ok: false, reason: "empty_phone", phone: "" };
  }

  if (raw.startsWith("+")) {
    const digits = raw.slice(1).replace(/\D/g, "");
    if (digits.length < 8 || digits.length > 15) {
      return { ok: false, reason: "invalid_e164_length", phone: "" };
    }
    return { ok: true, phone: `+${digits}` };
  }

  let digits = raw.replace(/\D/g, "");
  if (!digits) {
    return { ok: false, reason: "invalid_digits", phone: "" };
  }

  if (digits.startsWith("00")) {
    digits = digits.slice(2);
    if (digits.length < 8 || digits.length > 15) {
      return { ok: false, reason: "invalid_e164_length", phone: "" };
    }
    return { ok: true, phone: `+${digits}` };
  }

  if (!country) {
    return { ok: false, reason: "missing_country_code", phone: "" };
  }

  const normalizedCountry = country.replace(/^0+/, "");
  if (!normalizedCountry) {
    return { ok: false, reason: "invalid_country_code", phone: "" };
  }

  // If user typed local leading 0, remove once before prefixing country.
  digits = digits.replace(/^0/, "");
  const e164Digits = `${normalizedCountry}${digits}`;
  if (e164Digits.length < 8 || e164Digits.length > 15) {
    return { ok: false, reason: "invalid_e164_length", phone: "" };
  }

  return { ok: true, phone: `+${e164Digits}` };
}
